import { Box, Text } from '@domain-group/suit-theme'

interface BrandedModuleHeaderProps {
  accentColor?: string,
  backgroundColour?: string,
  boxProps?: Record<string, unknown>,
  title: string,
}

const BrandedModuleHeader = (props: BrandedModuleHeaderProps) => {
  const {
    accentColor, backgroundColour = '#ffffff', boxProps, title,
  } = props

  return (
    <Box
      backgroundColor={backgroundColour}
      justifyContent="start"
      paddingY="large"
      {...boxProps}
    >
      <Box flexDirection="column" width="100%">
        <Text fontSize="small" fontWeight={600}>{title.toUpperCase()}</Text>

        <Box
          borderBottom="3px solid"
          borderColor={accentColor}
          overflow="visible"
          paddingY="small"
          width="48px"
        />
      </Box>
    </Box>
  )
}
export default BrandedModuleHeader
